/** Player hairstyles are authored meshes. IDs persist independently of hair colour. */
export const FEMALE_HAIRSTYLES = [
  {id:'wavy-shoulder',label:'Swaying',cut:'Long waves'},
  {id:'pixie',label:'Kindling',cut:'Pixie cut'},
  {id:'short-bob',label:'Musing',cut:'Short swept bob'},
  {id:'side-shave',label:'Daring',cut:'Side shave'},
  {id:'braid',label:'Weaving',cut:'Braid'},
] as const;
export type FemaleHairId = typeof FEMALE_HAIRSTYLES[number]['id'];
export const MALE_HAIRSTYLES = [
  {id:'medium-tousled',label:'Drifting',cut:'Medium tousled'},
  {id:'side-part',label:'Considering',cut:'Side part'},
  {id:'shoulder-straight',label:'Flowing',cut:'Shoulder-length straight'},
  {id:'wavy-medium',label:'Roaming',cut:'Wavy medium'},
  {id:'top-knot',label:'Gathering',cut:'Top knot'},
] as const;
export type MaleHairId = typeof MALE_HAIRSTYLES[number]['id'];
export type HairId = FemaleHairId | MaleHairId | 'spiky' | 'none';
export const HAIR_CATALOG = {
  male: [{id:'spiky',label:'Stirring',cut:'Swept spikes'},...MALE_HAIRSTYLES,{id:'none',label:'Shaved'}],
  female: [{id:'spiky',label:'Tending',cut:'Short ponytail'},...FEMALE_HAIRSTYLES,{id:'none',label:'Shaved'}],
} as const;
export function validateHairId(raw: unknown, body: string): HairId {
  return HAIR_CATALOG[body === 'female' ? 'female' : 'male'].some(h => h.id === raw) ? raw as HairId : 'spiky';
}
export function hairAsset(body: string, raw: unknown): string | null {
  const id = validateHairId(raw, body);
  if (id === 'none') return null;
  if (body !== 'female') return `/models/male/hair_${id}.glb`;
  return `/models/female/hair_${id === 'spiky' ? 'long' : id}.glb`;
}
